import { ReactNode, useEffect, useState } from 'react';
import { getFileExtension, getMimeTypeFromExtension } from 'utils/utils';

interface AppVideoPlayerProps {
  url?: string;
  fileName?: string;
  mimeType?: string;
  className?: string;
  fallback?: ReactNode;
  width?: string | number;
}

export function AppVideoPlayer({ url, fileName, mimeType, className, fallback, width = '100%' }: AppVideoPlayerProps) {
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setHasError(false);
  }, [url, fileName, mimeType]);

  const finalMimeType = mimeType || (fileName ? getMimeTypeFromExtension(getFileExtension(fileName), 'video') : '');

  if (hasError || !url) {
    return <>{fallback}</>;
  }

  const sourceProps: { src: string; type?: string } = { src: url };
  if (finalMimeType) {
    sourceProps.type = finalMimeType;
  }

  return (
    <video controls playsInline className={className} style={{ width }} onError={() => setHasError(true)}>
      <source {...sourceProps} />
      {fallback}
    </video>
  );
}
